import React from "react";
import Select from "react-select";
import BaseInput from "../base-input";

const SelectField = ({ id, value, options, onChange, label, required, denySearch = false, ...restProps }) => (
    <div className="select-field">
        <BaseInput
            label={label}
            required={required}
        >
            <Select
                id={id}
                classNamePrefix="select-field"
                value={value}
                options={options}
                onChange={onChange}
                required={required}
                isSearchable={!denySearch}
                {...restProps}
            />
        </BaseInput>
    </div>
);

export default SelectField; 
